import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriUserChangePasswordFormComponent } from '../../components/gonvarri-user-change-password-form/gonvarri-user-change-password-form.component';
import {RouterModule} from "@angular/router";
import {NgSelectModule} from "@ng-select/ng-select";
import {FeaturesConfigModule, I18nModule, provideConfig, UrlModule} from "@spartacus/core";
import {ReactiveFormsModule} from "@angular/forms";
import {FormErrorsModule, KeyboardFocusModule, PasswordVisibilityToggleModule} from "@spartacus/storefront";
import {CardModule} from "@spartacus/organization/administration/components";

@NgModule({
  declarations: [
    GonvarriUserChangePasswordFormComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    UrlModule,
    I18nModule,
    ReactiveFormsModule,
    FormErrorsModule,
    KeyboardFocusModule,
    PasswordVisibilityToggleModule,
    FeaturesConfigModule,
    CardModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        UserChangePasswordFormComponent: {
          component: GonvarriUserChangePasswordFormComponent
        }
      }
    })
  ]
})
export class GonvarriUserChangePasswordFormModule { }
